<script>
    import PageBox from "../layouts/PageBox.svelte";
    import ContentBox from "../layouts/ContentBox.svelte";
    import Button from "../ui_elements/Button.svelte";
    import { push } from 'svelte-spa-router';
</script>

<PageBox pageTitle="Adminbereich">  
    <ContentBox>
        Die folgenden Funktionalitäten funktionieren nur eingeschränkt!

        <h2>Nutzer erstellen</h2>
        <Button on:click={() => push("/admin/add-user")}>Neuen Nutzer registrieren</Button>
        <Button on:click={() => push("/admin/add-multiple-users")}>Mehrere neue Nutzer registrieren (Klassenregistrierung)</Button>

        <h2>Fragebogen bearbeiten</h2>
        <Button on:click={() => push("/admin/add-question")}>Neue Frage hinzufügen</Button>

        <h2>Berufe bearbeiten</h2>
        <Button on:click={() => push("/admin/add-job")}>Neuen Beruf hinzufügen</Button>
    </ContentBox>
</PageBox>
